import { useTitle } from "@/hooks/use-title.hook.ts";
import { useTemplateEditPage } from "@/pages/talent/surveys/templates/edit/pages/survey-template-edit-pages.tsx";
import { SurveyTemplateTitleSlot } from "@/pages/talent/surveys/templates/edit/pages/SurveyTemplateTitleSlot.tsx";
import { SurveyTemplateEditDetailsPage } from "@/pages/talent/surveys/templates/edit/pages/SurveyTemplateEditDetailsPage.tsx";
import { SurveyTemplateEditQuestionsPage } from "@/pages/talent/surveys/templates/edit/pages/SurveyTemplateEditQuestionsPage.tsx";
import { SurveyTemplateEditPageStep } from "@/pages/talent/surveys/templates/edit/survey-template-edit.ts";
import { useSurveyTemplateById } from "@/queries/surveys/use-survey-templates.query.ts";
import { Button, FullScreenPage, Skeleton } from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export const SurveyTemplateEditPage = () => {
  const { t } = useTranslation();
  const { id, step } = useParams();

  const { confirmExit } = useTemplateEditPage();

  const { data: template } = useSurveyTemplateById(id ? parseInt(id) : undefined, !!id);

  useTitle(template?.title, t("surveys:survey_template"));

  const currentStep = useMemo(() => {
    if (step) {
      return step as SurveyTemplateEditPageStep;
    }
    return SurveyTemplateEditPageStep.details;
  }, [step]);

  if (template) {
    if (currentStep == SurveyTemplateEditPageStep.details) {
      return <SurveyTemplateEditDetailsPage key={template.id} template={template} />;
    } else if (currentStep == SurveyTemplateEditPageStep.questions) {
      return <SurveyTemplateEditQuestionsPage template={template} />;
    }
  }

  return (
    <FullScreenPage
      backSlot={
        <Button variant={"secondary"} size={"lg"} onClick={confirmExit}>
          {t("common:exit")}
        </Button>
      }
      titleSlot={<SurveyTemplateTitleSlot step={SurveyTemplateEditPageStep.details} />}
      isCenterVertical={false}
      contentSize={"md"}
    >
      <Skeleton className={"w-full h-10"} />
    </FullScreenPage>
  );
};
